import { paths } from "src/routes/paths"

import { Iconify } from "../../common/iconify"

// ----------------------------------------------------------------------

export const internalUserNavData = [
    {
        subheader: "",
        items: [
            {
                title: "Workspaces",
                path: paths.internalUser.root,
                icon: <Iconify icon="mdi:office-building" width={24} height={24} />,
            },
            {
                title: "Credits & VAS",
                path: paths.internalUser.credits,
                icon: <Iconify icon="material-symbols:credit-card" width={24} height={24} />,
            },
            {
                title: "Jobs and Leads",
                path: paths.internalUser.jobsAndLeads,
                icon: <Iconify icon="mdi:briefcase" width={24} height={24} />,
            },
            {
                title: "Generate OTP",
                path: paths.internalUser.generateOtp,
                icon: <Iconify icon="mdi:shield-key" width={24} height={24} />,
            },
            {
                title: "Team Assignment",
                path: paths.internalUser.teamAssignments,
                icon: <Iconify icon="mdi:account-switch-outline" width={24} height={24} />,
            },
            {
                title: "Prompts",
                path: paths.internalUser.prompts,
                icon: <Iconify icon="mdi:text-box-edit" width={24} height={24} />,
            },
        ],
    },
]
